var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconSuccess = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12.586,
  height: 12.585,
  viewBox: "0 0 12.586 12.585",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_371",
  "data-name": "Group 371",
  transform: "translate(0.4 0.4)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_208",
  "data-name": "Path 208",
  d: "M423.623,822.979a5.888,5.888,0,1,0-1.088-3.4A5.889,5.889,0,0,0,423.623,822.979Z",
  transform: "translate(-422.535 -813.682)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.8
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_209",
  "data-name": "Path 209",
  d: "M435.779,833.28l4.2-4.746a.4.4,0,0,0,0-.537h0a.4.4,0,0,0-.6,0l-3.605,4a.4.4,0,0,1-.6,0l-1.637-1.822a.4.4,0,0,0-.584-.016l-.022.022a.4.4,0,0,0-.017.552l2.257,2.546A.4.4,0,0,0,435.779,833.28Z",
  transform: "translate(-430.558 -824.747)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSuccess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_success.1cc452d7.svg";
export { ForwardRef as ReactComponent };